<template>
  <div class="step2">
    <div class="step2-loading" v-show="!showReport&&serviceStep.step===1">
      <span class="step2-icon el-icon-time"></span>
      <p class="loading-text">服务报告生成中，请稍后...</p>
    </div>
    <reportPage v-if="showReport" />
  </div>
</template>
<script>
import reportPage from "../reportDeal.vue";
import { mapState, mapActions } from "vuex";
import { fetchGet, fetchPost } from "@/libs/reqCommon";

export default {
  name: "step2",
  components: { reportPage },
  data() {
    return {
      showReport: false,
      timeout:''
    };
  },
  computed: {
    ...mapState({
      serviceStep: state => state.serviceReport.serviceStep,
      reportQuery: state => state.serviceReport.reportQuery,
      reportcheckCookCooks: state => state.serviceReport.reportcheckCookCooks
    })
  },
  methods: {
    saveValidation() {
      let params = {
        param: JSON.stringify(this.reportcheckCookCooks)
      };
      return new Promise(r => {
        fetchPost("hcm/hcmChannelServiceReport/saveValidation", params).then(
          res => {
            this.getstatus().then(() => {
              r(res.data);
            });
          }
        );
      });
    },
    getstatus() {
      let canGo = true;
      return new Promise(r => {
        fetchGet("hcm/hcmChannelServiceReport/getstatus", {
          statusid: this.reportcheckCookCooks[0].statusid
        }).then(result => {
          if (result.status === "10000") {
            result.data.data.forEach(element => {
              if (element.status == "0") {
                canGo = false;
              } 
            });
          }
          if (!canGo) {
            this.timeout=setTimeout(() => {
              this.getstatus();
            }, 5000);
          } else {
             console.log('结束循环！')
            clearTimeout(this.timeout)
            r();
          }
        });
      });
    },
    async loadingReport() {
      if (this.reportcheckCookCooks.length === 0) {
        this.showReport = true;
        return false;
      }
      this.saveValidation().then(flag => {
        if (flag) {
          this.showReport = true;
          let query = {
            ...this.reportQuery,
            flag
          };
          this.$store.commit("createQuery", query);
        }
      });
    }
  },
  mounted() {
    this.loadingReport();
  },
  destroyed(){
     clearTimeout(this.timeout)
  }
};
</script>
<style lang="scss">
.step2 {
  margin: 20px 0 0 0;
  &-icon {
    font-size: 30px;
    color: #3aa0ff;
    margin: 50px 20px 0 0;
    // background: url('../../../../assets/img/other/await_icon.png') no-repeat;
  }
  &-loading {
    height: 300px;
    text-align: center;
  }
  .loading-text {
    line-height: 40px;
  }
}
</style>